var map = {
	"./logo-calendly.webp": 83877,
	"./logo-flutter.webp": 29534,
	"./logo-highlevel.webp": 5236,
	"./logo-mailchimp.webp": 2262,
	"./logo-mailgun.webp": 45631,
	"./logo-maps.webp": 3953,
	"./logo-paypal.webp": 69256,
	"./logo-pipedrive.webp": 18071,
	"./logo-quickbooks.webp": 30730,
	"./logo-react.webp": 84321,
	"./logo-roposo.webp": 79402,
	"./logo-shopify.webp": 72618,
	"./logo-stripe.webp": 73161,
	"./logo-twilio.webp": 21483,
	"./logo-woo.webp": 94072,
	"./logo-zoom.webp": 77062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72985;